import { getMatchedTaskUrl } from 'components/ProjectSearchMatches';

import { UserTask } from '../types';

export const getDashboardTaskSearchContext = (
  task: UserTask,
  query: string,
  pageQuery: string
) => {
  const matches = task.matches || [];
  const hasTitle = !!task.title?.trim();

  return {
    matchedAssignees: task.matchedAssignees || [],
    matchedComments: task.matchedComments || [],
    matchedDescription:
      hasTitle && matches.includes('description')
        ? task.description
        : undefined,
    matchedUrl: getMatchedTaskUrl(matches, task.site, task.url, pageQuery),
    textSearchHighlight: matches.includes(
      hasTitle ? 'task_title' : 'description'
    )
      ? query
      : undefined
  };
};
